module.exports = __webpack_public_path__ + "img/sp-1.f4b571e5.png";